<template>
    <div>
        <vx-image-preview
            v-if="isImage"
            :title="filename"
            :active.sync="previewActive"
            :src="imageSrc"
            :alt="filename"
        />
        <vx-dropdown
            class="dropdown-body"
            menu-class="resource-link-dropdown-body"
            hide-pointer
            ref="dropdown"
            justify="center"
            align="top"
        >
            <a class="link" @click="download">
                {{ filename }}
            </a>
            <template slot="menu">
                <vx-card class="card">
                    <template v-if="isImage" slot="no-body">
                        <img :src="imageSrc" :alt="filename" @error="imageError = true" />
                    </template>
                    <div v-else class="flex items-center mb-3">
                        <vx-basic-icon class="mr-2" use-mdi icon="broken_image" />
                        <span>No Thumbnail Available</span>
                    </div>
                    <template slot="footer">
                        <div class="flex flex-wrap justify-end gap-2 buttons">
                            <vx-action-icon
                                v-if="isImage"
                                icon="ZoomInIcon"
                                color="primary"
                                is-button
                                @click="viewImage"
                            />
                            <vx-action-icon
                                icon="DownloadIcon"
                                color="primary"
                                is-button
                                @click="download"
                            />
                        </div>
                    </template>
                </vx-card>
            </template>
        </vx-dropdown>
    </div>
</template>

<script>
export default {
    name: 'vx-resource-link',
    props: {
        resource: {
            type: [Object, String]
        }
    },
    data() {
        return {
            validImageExt: ['jpeg', 'jpg', 'png'],
            previewActive: false,
            imageError: false
        }
    },
    computed: {
        isResourceObject() {
            return typeof this.resource === 'object'
        },
        filename() {
            if (this.isResourceObject) {
                return this.resource.filename
            }
            return 'Unknown File'
        },
        resourceId() {
            if (this.resource == null) {
                return null
            }
            if (this.isResourceObject) {
                return this.resource.id
            }
            return this.resource
        },
        imageSrc() {
            if (this.imageError || !this.isImage) {
                return this.$api.resources.getUrl(this.resourceId)
            }
            return this.$api.resources.getThumbnailUrl(this.resourceId)
        },
        isImage() {
            if (!this.isResourceObject) {
                return true
            }
            let fileExt = this.filename.split('.').pop()
            return this.validImageExt.contains(fileExt)
        }
    },
    methods: {
        download() {
            this.$api.resources.download(this.resourceId)
            this.$emit('downloaded', this.resourceId)
        },
        viewImage() {
            this.$refs.dropdown.close()
            this.previewActive = true
        }
    },
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped>
.link {
    cursor: pointer;
}
.card {
    margin-bottom: 0 !important;
}
img {
    max-width: 230px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    background-color: white;
    border-radius: 0.5rem;
}

::v-deep .vx-card .vx-card__footer {
    z-index: 200;
}
</style>

<style lang="scss">
// these styles are placed on an element at the document body
// therefore they need to be global to reach that location
.resource-link-dropdown-body {
    .vs-dropdown--custom {
        padding: 0 !important;
    }
}
.con-vs-dropdown--menu {
    &:after {
        content: none !important;
    }
}
</style>
